// auto-generated by Typewriter template _models.tst from PortCall.Services\FileUploads\SaveImageBindingModel.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';


// SaveImageRequestData is the class that SaveImageRequest serializes to/from
export interface SaveImageRequestData {
	
    RawUrl : string | null;
	
    CropX1 : number;
    CropX2 : number;
    CropY1 : number;
    CropY2 : number;
}

// SaveImageRequestOptions is the class which may be passed to the SaveImageRequest constructor to define optional initial data values
export interface SaveImageRequestOptions {
	
    RawUrl? : string | null;
	
    CropX1? : number;
    CropX2? : number;
    CropY1? : number;
    CropY2? : number;
}

export class SaveImageRequest {
	
    public RawUrl : DataSignal<string | null>;
	
    public CropX1 : DataSignal<number>;
    public CropX2 : DataSignal<number>;
    public CropY1 : DataSignal<number>;
    public CropY2 : DataSignal<number>;

    constructor();
    constructor(data : SaveImageRequestOptions);
    constructor(data: SaveImageRequestOptions | null = null) {
	    
        this.RawUrl = jsonableObservable(S.value<string | null>(data && data.RawUrl !== undefined ? data.RawUrl : null));
	    
        this.CropX1 = jsonableObservable(S.value<number>(data && data.CropX1 !== undefined ? data.CropX1 : 0));
        this.CropX2 = jsonableObservable(S.value<number>(data && data.CropX2 !== undefined ? data.CropX2 : 0));
        this.CropY1 = jsonableObservable(S.value<number>(data && data.CropY1 !== undefined ? data.CropY1 : 0));
        this.CropY2 = jsonableObservable(S.value<number>(data && data.CropY2 !== undefined ? data.CropY2 : 0));
    }

    static key(obj : SaveImageRequest) {
        return ;
    }
    
    static dataKey(obj : SaveImageRequestOptions) {
        return ;
    }

    static update(obj : SaveImageRequest, data : SaveImageRequestOptions) {
        S.freeze(() => {
	        
            if (data.RawUrl !== undefined) obj.RawUrl(data.RawUrl);
	        
            if (data.CropX1 !== undefined) obj.CropX1(data.CropX1);
            if (data.CropX2 !== undefined) obj.CropX2(data.CropX2);
            if (data.CropY1 !== undefined) obj.CropY1(data.CropY1);
            if (data.CropY2 !== undefined) obj.CropY2(data.CropY2);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/SaveImageRequest.ts